import { c as _c } from "react/compiler-runtime";
import { IcoCode24 } from '@onefootprint/icons';
import type { Document } from '@onefootprint/request-types/dashboard';
import type { EntityVault } from '@onefootprint/types';
import { CodeBlock } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '../collapsible-section';
import getJsonKindText from './utils/get-json-kind-text';
import getRawJsonData from './utils/get-raw-json-data';
type RawJsonDataProps = {
  vault: EntityVault;
  document: Document;
};
const RawJsonData = t0 => {
  const $ = _c(8);
  const {
    vault,
    document
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.rawJsonData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  let t3;
  if ($[1] !== document || $[2] !== t || $[3] !== vault) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const rawJsonData = getRawJsonData(vault, document);
      if (!rawJsonData.length) {
        t3 = null;
        break bb0;
      }
      let t4;
      if ($[6] !== t) {
        t4 = t5 => {
          const {
            rawJsonKind,
            rawJsonData: rawJsonData_0
          } = t5;
          return <CollapsibleSection key={rawJsonKind} icon={IcoCode24} title={getJsonKindText(rawJsonKind) as string}><CodeBlock language="javascript" title={t(_temp)} isPrivate={true}>{rawJsonData_0}</CodeBlock></CollapsibleSection>;
        };
        $[6] = t;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      t2 = rawJsonData.map(t4);
    }
    $[1] = document;
    $[2] = t;
    $[3] = vault;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
};
export default RawJsonData;
function _temp($) {
  return $.json;
}